export interface ModalsHideActionType {
  type: '@modals/HIDE';
  payload: string;
}

export const hideModal = (modalId: string): ModalsHideActionType => ({
  type: '@modals/HIDE',
  payload: modalId,
});
